import { START_NEXT_INPUT, ANIMATE_STEP } from "./constants/events.constants";

export const animationMiddleware = store => {
  let animationFrameId = null;


  const animate = () => {
    const state = store.getState().events;

    if (!state.isAnimating) {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = null;

      if (state.inputIndex < state.events?.gameInputs?.length) {
        store.dispatch({ type: START_NEXT_INPUT });
      }
      return;
    }

    store.dispatch({ type: ANIMATE_STEP });
    animationFrameId = requestAnimationFrame(animate);
  };

  return next => action => {
    const result = next(action);

    if (action.type === START_NEXT_INPUT && !animationFrameId) {
      animationFrameId = requestAnimationFrame(animate);
    }

    return result;
  };
};
